<template>
  <div>
    <TaxToggleWells v-if="type === 'wells'" :taxToggle="taxToggle"></TaxToggleWells>
  </div>
</template>

<script>
import TaxToggleWells from "@/components/archive/tax-toggles/Wells.vue";

export default {
  components: {
    TaxToggleWells
  },
  name: "TaxToggle",
  data() {
    return {
      type: ws_vue_store['config'].tax_toggle
    };
  },
  created() {},
  methods: {
    taxToggle(event) {
      if ( !event) return;
      this.$store.commit('setTaxesEnabled', event.target.value === 'taxes_included');
      this.setCookie('ws_taxes_display_selection', event.target.value, 31);
      const customEvent = new Event('taxes-toggled');
      document.dispatchEvent(customEvent);

      const taxToggleEvent = new CustomEvent('update-taxes-display-vue-store', {'detail' : { 'selectedValue' : event.target.value} });
      document.dispatchEvent(taxToggleEvent);
    },
    setCookie(cookieKey, cookieValue, expirationDays) {
      let expiryDate = '';
      if (expirationDays) {
        const date = new Date();
        date.setTime(`${date.getTime()}${expirationDays || 30 * 24 * 60 * 60 * 1000}`);
        expiryDate = `; expiryDate=" ${date.toUTCString()}`;
      }
      document.cookie = `${cookieKey}=${cookieValue || ''}${expiryDate}; path=/`;
    },
  }
};
</script>
